import PropTypes from 'prop-types';

import { SCALING_PRICING_ITEM_LABELS } from 'common/constants';
import { parseDonationAmount } from 'common/utils';

import { useAccount } from '../../store/account/hooks';
import EditSubscriptionModal from './EditSubscriptionModal';

const ScalingPricingSubscriptionItemType = {
  FUNDRAISING_ESSENTIALS_SUITE: 'FUNDRAISING_ESSENTIALS_SUITE',
  AUTOMATED_CULTIVATION: 'AUTOMATED_CULTIVATION',
  DONOR_ACQUISITION: 'DONOR_ACQUISITION',
  DONATION_PROCESSING: 'DONATION_PROCESSING',
  FUNDRAISING_SUPPORT_SPECIALIST: 'FUNDRAISING_SUPPORT_SPECIALIST',
};

const SubscriptionSummary = ({ orderTotal, orderSubTotal, orderDiscount, orderDiscountName }) => {
  const { account } = useAccount();

  const { subscription } = account;

  return (
    <>
      <div className="flex items-center justify-between">
        <h2 className="text-h5 font-semibold">Subscription Summary</h2>
        <EditSubscriptionModal />
      </div>

      <div className="divide-y">
        <div className="flex justify-between pb-1 text-base">
          <div>Number of Contacts:</div>
          <div className="font-semibold">Up to {subscription?.databaseStartingSize}</div>
        </div>

        <div className="pb-1">
          <div className="flex justify-between py-0.5">
            <div>{SCALING_PRICING_ITEM_LABELS.FUNDRAISING_ESSENTIALS_SUITE}</div>
            <div className="font-semibold">
              {parseDonationAmount(
                subscription.items[ScalingPricingSubscriptionItemType.FUNDRAISING_ESSENTIALS_SUITE]?.yearlyBasePrice /
                  100 /
                  (account?.subscription?.interval === 'yearly' ? 1 : 12),
              )}
            </div>
          </div>
          <div className="flex justify-between py-0.5">
            <div>{SCALING_PRICING_ITEM_LABELS.AUTOMATED_CULTIVATION}</div>
            <div className="font-semibold">
              {parseDonationAmount(
                subscription.items[ScalingPricingSubscriptionItemType.AUTOMATED_CULTIVATION]?.yearlyBasePrice /
                  100 /
                  (account?.subscription?.interval === 'yearly' ? 1 : 12),
              )}
            </div>
          </div>
          <div className="flex justify-between py-0.5">
            <div
              className={`${subscription.items[ScalingPricingSubscriptionItemType.DONOR_ACQUISITION]?.enabled ? '' : 'line-through'}`}
            >
              {SCALING_PRICING_ITEM_LABELS.DONOR_ACQUISITION}
              {subscription.items[ScalingPricingSubscriptionItemType.DONOR_ACQUISITION]?.enabled && '*'}
            </div>
            <div className="font-semibold">
              {subscription.items[ScalingPricingSubscriptionItemType.DONOR_ACQUISITION]?.enabled
                ? parseDonationAmount(
                    subscription.items[ScalingPricingSubscriptionItemType.DONOR_ACQUISITION]?.yearlyBasePrice /
                      100 /
                      (account?.subscription?.interval === 'yearly' ? 1 : 12),
                  )
                : 'N/A'}
            </div>
          </div>
          <div className="flex justify-between py-0.5">
            <div
              className={`${subscription.items[ScalingPricingSubscriptionItemType.DONATION_PROCESSING]?.enabled ? '' : 'line-through'}`}
            >
              {SCALING_PRICING_ITEM_LABELS.DONATION_PROCESSING}
            </div>
            <div className="font-semibold">
              {subscription.items[ScalingPricingSubscriptionItemType.DONATION_PROCESSING]?.enabled
                ? parseDonationAmount(
                    subscription.items[ScalingPricingSubscriptionItemType.DONATION_PROCESSING]?.yearlyBasePrice /
                      100 /
                      (account?.subscription?.interval === 'yearly' ? 1 : 12),
                  )
                : 'N/A'}
            </div>
          </div>
          <div className="flex justify-between py-0.5">
            <div
              className={`${subscription.items[ScalingPricingSubscriptionItemType.FUNDRAISING_SUPPORT_SPECIALIST]?.enabled ? '' : 'line-through'}`}
            >
              {SCALING_PRICING_ITEM_LABELS.FUNDRAISING_SUPPORT_SPECIALIST}
            </div>
            <div className="font-semibold">
              {subscription.items[ScalingPricingSubscriptionItemType.FUNDRAISING_SUPPORT_SPECIALIST]?.enabled
                ? parseDonationAmount(
                    subscription.items[ScalingPricingSubscriptionItemType.FUNDRAISING_SUPPORT_SPECIALIST]
                      ?.yearlyBasePrice /
                      100 /
                      (account?.subscription?.interval === 'yearly' ? 1 : 12),
                  )
                : 'N/A'}
            </div>
          </div>
        </div>

        {orderDiscountName && orderDiscount && (
          <div className="pb-1">
            <div className="flex justify-between py-0.5">
              <div>Sub Total:</div>
              <div className="text-right font-semibold">{parseDonationAmount(orderSubTotal / 100)}</div>
            </div>
            <div className="flex justify-between py-0.5">
              <div>{orderDiscountName}:</div>
              <div className="text-right font-semibold">-{parseDonationAmount(orderDiscount / 100)}</div>
            </div>
          </div>
        )}

        <div className="flex justify-between pt-1">
          <div>Total:</div>
          <div className="text-right font-semibold">
            {parseDonationAmount(orderTotal / 100)}
            <br />
            <span className="text-base">per {account?.subscription?.interval === 'yearly' ? 'year' : 'month'}</span>
          </div>
        </div>
      </div>

      {subscription.items[ScalingPricingSubscriptionItemType.DONOR_ACQUISITION]?.enabled && (
        <div className="text-sm leading-tight">
          *If we find that your organization isn&apos;t a good fit for Donor Acquisition after our review, we will
          refund that portion of your subscription payment.
        </div>
      )}
    </>
  );
};

SubscriptionSummary.propTypes = {
  orderTotal: PropTypes.number.isRequired,
  orderSubTotal: PropTypes.number.isRequired,
  orderDiscount: PropTypes.number.isRequired,
  orderDiscountName: PropTypes.string,
};

export default SubscriptionSummary;
